import webui from "@tinqin/tinqin-web-ui";
import translations from "./translations.json";
/**
 * Translation must be added in translations.json
 * Supports nested objects
 * @params { string } key - string path to translation
 * example - "from", "event.date.from"
 */
const translate = key => {
    const locale = webui.getGlobalProperty("locale");
    if (!translations[locale]) {
        return key;
    }
    const result = key.split(".").reduce((prev, current) => prev[current], translations[locale]);
    if (!result) {
        return key;
    }
    return result;
};
export default translate;
